import React from 'react';

const LABELS = [
  "Golden Hour",
  "Still Water",
  "Deep Woods",
  "Quiet Dawn"
];

export default function HeroContent({ activeVideo, onVideoChange, onOpenContact }) {
  const isDarkText = activeVideo === 2;
  const textColorClass = isDarkText ? 'text-dark-text' : 'text-white';
  const borderClass = isDarkText ? 'border-dark-text' : 'border-white';

  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData(e.currentTarget);
    const brand = formData.get('brand')?.toString().trim();
    
    // Hand over the brand text to trigger the form scroll and open
    if (onOpenContact) {
      onOpenContact(brand);
    }
  };

  return (
    <div className="flex-1 flex flex-col items-center justify-center px-6 z-20 relative text-center w-full max-w-5xl mx-auto">
      <div className={`liquid-glass rounded-full px-4 py-1.5 text-xs sm:text-sm mb-8 transition-colors duration-700 ${textColorClass}`}>
        From HSN broadcast floors to Hollywood union sets — now building listing videos that convert.
      </div>
      
      <h1 className={`font-instrument italic text-4xl sm:text-5xl md:text-7xl lg:text-[5.5rem] leading-[1.1] max-w-4xl transition-colors duration-700 ${textColorClass}`}>
        Your Product Deserves <br className="hidden sm:block" /> Video That Converts
      </h1>
      
      <p className={`mt-6 text-base sm:text-lg max-w-xl leading-relaxed mx-auto font-sans transition-colors duration-700 ${isDarkText ? 'text-dark-text/90' : 'text-white/90'}`}>
        Studio-quality Amazon listing videos delivered in 7 days. Built by the person who watched HSN sales data in real time and called the shots — now doing the same for your listing.
      </p>

      <form 
        onSubmit={handleSubmit} 
        className="mt-10 liquid-glass rounded-full p-2 flex flex-col sm:flex-row items-center w-full max-w-[320px] sm:max-w-sm gap-2"
      >
        <input 
          type="text" 
          name="brand"
          placeholder="Your brand name"
          className={`bg-transparent border-none outline-none px-4 py-2 w-full text-sm font-sans placeholder:transition-colors placeholder:duration-700 transition-colors duration-700 ${isDarkText ? 'text-dark-text placeholder:text-dark-text/60' : 'text-white placeholder:text-white/60'}`}
        />
        <button 
          type="submit"
          className="bg-white text-black text-sm font-semibold px-6 py-3 rounded-full w-full sm:w-auto hover:bg-white/90 transition-colors whitespace-nowrap"
        >
          Begin &rarr;
        </button>
      </form>

      <div className="mt-16 flex flex-wrap justify-center gap-4 sm:gap-8">
        {LABELS.map((label, idx) => {
          const isActive = activeVideo === idx;
          return (
            <button
              key={idx}
              onClick={() => onVideoChange(idx)}
              className={`pb-2 text-sm font-medium font-sans transition-all duration-700 border-b-2 ${
                isActive 
                  ? `${borderClass} ${textColorClass} opacity-100` 
                  : `border-transparent ${textColorClass} opacity-50 hover:opacity-80`
              }`}
            >
              {label}
            </button>
          );
        })}
      </div>
    </div>
  );
}